export const LOAD_STANDARDSTATI = 'load_standardstati';
export const LOAD_STANDARDSUBSTATI = 'load_standardsubstati';
export const LOAD_STANDARDTYPEN = 'load_standardtypen';
export const LOAD_STANDARDGRUPPEN = 'load_standardgruppen';

export const LOAD_STANDORTE = 'load_standorte';
export const LOAD_KATEGORIEN = 'load_kategorien';

export const LOAD_ANZAHL_STANDARD = 'load_anzahl_standard';
